import { string } from '@philips-emr/tws-core/lib/component/prop-types';
import { Formatter, registerFormatter } from '@philips-emr/tws-core/lib/services/model-service';
import { isEmptyOrBlankString } from '@philips-emr/tws-utils';

function format(origenPhone: string, options: CustomFormatterOptions = {}): string {
  let phoneFormatted: string = origenPhone;

  phoneFormatted = phoneFormatted.replace(/\D/g, '');
  phoneFormatted = phoneFormatted.replace(/^(\d)/, '($1');
  phoneFormatted = phoneFormatted.replace(/(.{3})(\d)/, '$1) $2');

  if (phoneFormatted.length == 9) {
    phoneFormatted = phoneFormatted.replace(/(.{1})$/, '-$1');
  } else if (phoneFormatted.length == 10) {
    phoneFormatted = phoneFormatted.replace(/(.{2})$/, '-$1');
  } else if (phoneFormatted.length == 11) {
    phoneFormatted = phoneFormatted.replace(/(.{3})$/, '-$1');
  } else if (phoneFormatted.length == 12) {
    phoneFormatted = phoneFormatted.replace(/(.{4})$/, '-$1');
  } else if (phoneFormatted.length > 12) {
    phoneFormatted = phoneFormatted.replace(/(.{4})$/, '-$1');
  }

  if (isEmptyOrBlankString(phoneFormatted)) {
    if (!options || isEmptyOrBlankString(options.defaultValue)) {
      return '';
    }

    return options.defaultValue ?? '';
  }

  return phoneFormatted;
}

format.optionTypes = {
  defaultValue: string,
};

format.defaultOptions = { defaultValue: '' };

interface CustomFormatterOptions {
  defaultValue?: '';
}

const PhoneFormatter: Formatter<string, CustomFormatterOptions> = {
  format,
  parse: () => '',
  validate: () => [],
  getPattern: () => '',
};

export default registerFormatter('phone-number', PhoneFormatter);

